module.exports = __webpack_public_path__ + "static/4-d3057d7c3c00f11508b48de7d7bbda9c.jpg";